import React from "react";
import { ArrowUpRight } from "lucide-react";

export const MatchedProducts = ({ products = [], matchedIds = [], reasonsByProduct = {} }) => {
  const ordered = matchedIds
    .map((id) => products.find((p) => p.id === id))
    .filter(Boolean);
  if (!ordered.length) return null;
  return (
    <div data-testid="matched-products">
      <div className="flex items-center gap-3 mb-4">
        <span className="lw-eyebrow">Matched Products</span>
        <span className="flex-1 gold-hairline opacity-50" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {ordered.map((p) => {
          const reasons = reasonsByProduct[p.id] || [];
          return (
            <article
              key={p.id}
              data-testid={`matched-product-${p.id}`}
              className="lw-card p-5 flex flex-col h-full"
            >
              <span className="lw-pill self-start mb-3">
                Ages {p.age_range_min}–{p.age_range_max}
              </span>
              <h4 className="font-serif-display text-lg text-lw-navy leading-snug">
                {p.name}
              </h4>
              <p className="mt-1.5 text-sm text-lw-muted leading-relaxed">
                {p.tagline}
              </p>
              {reasons.length > 0 && (
                <ul className="mt-3 space-y-1.5">
                  {reasons.map((r, i) => (
                    <li
                      key={i}
                      className="flex items-start gap-2 text-xs text-lw-navy/80"
                    >
                      <span
                        aria-hidden="true"
                        className="mt-1.5 h-1 w-1 rounded-full bg-lw-gold flex-shrink-0"
                      />
                      {r}
                    </li>
                  ))}
                </ul>
              )}
              <a
                href="/#solutions"
                data-testid={`matched-product-cta-${p.id}`}
                className="mt-4 inline-flex items-center gap-1.5 font-sans-ui text-xs font-semibold text-lw-navy hover:text-[#8a6a2b] transition-colors"
              >
                Learn more <ArrowUpRight size={14} />
              </a>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default MatchedProducts;
